import { useQuery } from "@apollo/client";
import { GET_ALL_FINANCE_TREE_ITEMS } from "../graphql/queries/financeTree.graphql";

interface FinanceTreeItemResponse {
  id: number;
  level: number | null;
  serialNumber: string;
  name: string;
  nameAr: string;
  slug: string;
}

interface GetAllFinanceTreeItemsData {
  getAllFinanceTreeItems: FinanceTreeItemResponse[];
}

export const useFinanceTreeItems = () => {
  return useQuery<GetAllFinanceTreeItemsData>(GET_ALL_FINANCE_TREE_ITEMS);
};

